<template>
  <div class="shadow text-main-color absolute py-4 rounded-4 capitalize bottom-full left-1/2 transform -translate-x-1/2 mb-10 text-14 border"
       :class="isDarkMode ? 'bg-book border-project' : 'bg-white shadow-user-badge border border-grey-500'"
  >
    <UserBadge
      v-for="u in users"
      :key="u.id"
      :first-name="u.profile.firstName"
      :last-name="u.profile.lastName"
      :color="u.profile.color"
      color-height="h-18"
      class="cursor-default text-app-color rounded-6 py-2 px-10 truncate"
    />
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { useStore } from 'vuex'

export default defineComponent({
  props: {
    id: Number,
    messageReactions: Array
  },

  setup (props) {
    const { getters } = useStore()

    const dropdownRef = ref(null)

    const users = computed(() => props.messageReactions?.filter(item => item.reactionId === props.id).map(item => item.user))

    const isDarkMode = computed(() => getters.isDarkMode)

    return {
      // ref
      dropdownRef,
      // data
      // computed
      users,
      isDarkMode
      // function
    }
  }
})
</script>
